<template>
  <div fluid>
    <HeaderBar>
      <v-icon slot="icon">add</v-icon>
      Add Employee
    </HeaderBar>

    <v-layout row>
      <v-flex grow class="mr-2">
        <v-layout column>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                v-model="firstName"
                label="First Name"
              ></v-text-field>
            </v-flex>
            <v-flex class="mr-2">
              <v-text-field v-model="lastName" label="Last Name"></v-text-field>
            </v-flex>
            <v-flex shrink>
              <v-switch label="Use Dr. Title?" v-model="drTitle"> </v-switch>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                v-model="email"
                label="Email (used as login)"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                :type="showPass ? 'text' : 'password'"
                v-model="password"
                label="Password"
                @click:append="showPass = !showPass"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                :append-icon="showPassConfirm ? 'visibility' : 'visibility_off'"
                :type="showPassConfirm ? 'text' : 'password'"
                v-model="passwordConfirm"
                label="Confirm Password"
                @click:append="showPassConfirm = !showPassConfirm"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <v-menu
                    ref="startDateMenu"
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="startDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        hint="YYYY/MM/DD"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.startDateMenu.save(startDate)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>

        <v-flex class="mt-4">
          <h2 class="headline">
            Add Employee to All Locations of Geo Tag (<span class="subtle"
              >not required</span
            >)
          </h2>
          <v-autocomplete
            :items="geotagStates"
            label="Geo Tags"
            v-model="geotagSelection"
            clearable
            class="mr-4"
          >
          </v-autocomplete>
        </v-flex>
      </v-flex>

      <v-flex shrink>
        <v-layout column>
          <v-flex>
            <v-btn
              @click="createEmployee()"
              block
              :disabled="!newEmployeeValid"
              color="success"
            >
              Save &amp; Create
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn to="/hr/employees" block color="error">
              Cancel
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import HeaderBar from "@/components/base/header-bar.vue";
import employeeApi from "@/api/employee";
import collectionsApi from "@/api/collections";

export default {
  components: {
    HeaderBar
  },
  created() {
    collectionsApi.getGeotagStates({}, states => {
      this.geotagStates = states;
    });
  },
  watch: {},
  computed: {
    ...mapState("userAuth", ["user"]),
    newEmployeeValid() {
      return (
        this.firstName &&
        this.lastName &&
        this.email &&
        this.password &&
        this.password === this.passwordConfirm
      );
    }
  },
  methods: {
    createEmployee() {
      employeeApi.create(
        {
          employee: {
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            dr_title: this.drTitle,
            password: this.password,
            password_confirmation: this.passwordConfirm,
            start_date: this.startDate
          },
          geotagSelection: this.geotagSelection
        },
        res => {
          const message = `Created employee ${this.firstName} ${this.lastName}!`;
          this.$store.dispatch("global/showSnackbarSuccess", {
            message: message
          });
          this.$router.push({
            name: "employeeDetail",
            params: { employeeId: res.id }
          });
        },
        error => {
          const message = `Something went wrong creating that employee...`;
          this.$store.dispatch("global/showSnackbarError", {
            message: message
          });
        }
      );
    }
  },
  data: function() {
    return {
      startDateMenu: false,
      firstName: "",
      lastName: "",
      email: "",
      drTitle: false,
      startDate: new Date().toISOString().substr(0, 10),
      password: "",
      passwordConfirm: "",
      showPass: false,
      showPassConfirm: false,
      geotagStates: [],
      geotagSelection: null
    };
  }
};
</script>

<style scoped></style>
